export const isHTML = (string) => {
  return RegExp(/<\w{1,10}>|<script/gi).test(string);
};
